(function ( $ ) {

    (function () {
        $("#send-mail-form, #contact-form").submit(function (e) {
            e.preventDefault()
            let name = $(this).find("[name=\"name\"]").val();
            let phoneNumber = $(this).find("[name=\"phone\"]").val();
            let email = $(this).find("[name=\"email\"]").val();
            let message = $(this).find("[name=\"message\"]").val();
            let token = $('meta[name="csrf-token"]').attr('content');
            let pathArray = window.location.pathname.split('/');
            const lang = pathArray[1];
            let title = (lang !=="ua") ? "Повідомлення відправлено" : "Сообщение отправлено";
            $(this).find(".spinner-for-btn").css('display','inline-block');
            $(this).find("input[type='submit']").prop('disabled', true);
            axios
                .post(`/ajax/contact-form`, {
                    name: name,
                    phoneNumber: phoneNumber,
                    email: email,
                    message: message,
                }, {
                    headers: {
                        'X-CSRF-TOKEN': token
                    }
                })
                .then(resp => {
                    $(this).find("[name=\"name\"]").val("");
                    $(this).find("[name=\"phone\"]").val("");
                   $(this).find("[name=\"email\"]").val("");
                    $(this).find("[name=\"message\"]").val("");
                    $('.popup-frame').fadeOut();
                    $('.js-popup').fadeOut();
                    $('html').removeClass('open-frame');
                    // swal({
                    //     title: title,
                    //     icon: 'success',
                    //     confirmButtonText: 'Ок'
                    // });
                    window.location.href= (lang === "ua") ? "/ua/message-sent" : "message-sent";
                })
                .catch(error => {

                })
                .then(() => {
                    $(this).find(".spinner-for-btn").hide();
                    $(this).find("input[type='submit']").prop('disabled', false);
                });
        });
    }());

}( jQuery ));
